<template>
    <div>
        <label
            class="flex items-start gap-2"
            :class="{'cursor-pointer': !disabled}"
        >
            <span
                class="w-[20px] h-[20px] rounded mt-1 flex items-center justify-center"
                :class="{
                    'border-2 m-0 mt-0.5': iconType === 'filled', //同意條款的線框加粗
                    'border-blue-700 border-2' : iconType === 'arc', // 永久居留證選項
                    'border-blue-700': !disabled && iconType === 'filled',
                    'border-gray-900': !disabled && iconType === 'default',
                    'border': iconType === 'default', //保單選項
                    'border-gray-600': disabled,
                    'bg-blue-700': iconType === 'filled' && checked,
                }"
            >
                <span
                    v-if="checked"
                    class="w-3"
                >
                    <IconCheck
                        :class="{'text-white': iconType === 'filled', 'text-blue-700': iconType === 'default' || 'arc'}"
                    />
                </span>
                <input
                    v-model="checked"
                    type="checkbox"
                    class="hidden"
                    :disabled="disabled"
                >
            </span>

            <span
                class="flex-1 leading-6 font-bold"
                :class="{'text-[14px]': size === 's', 'text-gray-600': disabled}"
            >{{ text }}</span>
        </label>
    </div>
</template>

<script>
import IconCheck from '@/components/icons/Check';
/**
 * 表單-確認「我暸解....」、商品自由選的類別（無代碼）
 */
export default {
    name: 'FormCheckBox',
    components: {IconCheck},
    props: {
        /**
         * 按鈕可否被勾選
         */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         * 說明文字
         */
        text: {
            type: String,
            default: ''
        },
        /**
         * checked狀態的勾勾顏色
         */
        color: {
            type: String,
            default: 'blue'
        },
        /**
         * 狀態是否已被勾選
         */
        modelValue: {
            type: Boolean,
            default: false
        },
        /**
         * 勾選樣式
         * @values default, filled
         */
        iconType: {
            type: String,
            default: 'default' // default | filled
        },
        /**
         * 按鈕尺寸
         * @values s, m
         */
        size: {
            type: String,
            default: 'm' // s,m
        }
    },
    emits: ['update:modelValue'],
    data() {
        /**
         * @param {Boolean} checked 是否已被勾選
         */
        return {
            checked: false
        };
    },
    watch: {
        value() {
            /**
             * 更新勾選狀態
             */
            this.checked = this.value;
        },
        checked() {
            /**
             * 監聽checkbox是否已勾選
             * @property {Boolean} checkbox是否已勾選
             */
            this.$emit('update:modelValue', this.checked);
        }
    },
    mounted() {
        /**
         * 載入時設定勾選狀態
         */
        this.checked = this.modelValue;
    }
};
</script>
